// extracted by mini-css-extract-plugin
export default {"linkRow":"boxLessValue_linkRow__nGbOV"};